/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlInvitedByClientResponse } from './ControlInvitedByClientResponse';
import {
    ControlInvitedByClientResponseFromJSON,
    ControlInvitedByClientResponseFromJSONTyped,
    ControlInvitedByClientResponseToJSON,
} from './ControlInvitedByClientResponse';

/**
 * 
 * @export
 * @interface ControlPaginatedInvitedByClientResponse
 */
export interface ControlPaginatedInvitedByClientResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedInvitedByClientResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedInvitedByClientResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedInvitedByClientResponse
     */
    total: number;
    /**
     * 
     * @type {Array<ControlInvitedByClientResponse>}
     * @memberof ControlPaginatedInvitedByClientResponse
     */
    results: Array<ControlInvitedByClientResponse>;
}

/**
 * Check if a given object implements the ControlPaginatedInvitedByClientResponse interface.
 */
export function instanceOfControlPaginatedInvitedByClientResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedInvitedByClientResponseFromJSON(json: any): ControlPaginatedInvitedByClientResponse {
    return ControlPaginatedInvitedByClientResponseFromJSONTyped(json, false);
}

export function ControlPaginatedInvitedByClientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedInvitedByClientResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(ControlInvitedByClientResponseFromJSON)),
    };
}

export function ControlPaginatedInvitedByClientResponseToJSON(value?: ControlPaginatedInvitedByClientResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'total': value.total,
        'results': ((value.results as Array<any>).map(ControlInvitedByClientResponseToJSON)),
    };
}

